import BunkeyAPI from '../api/BunkeyAPI'
import {
  ASSET_LAST_UPLOAD_GET_DATA,
  ASSET_LAST_UPLOAD_GET_DATA_SUCCESS,
  ASSET_LAST_UPLOAD_GET_DATA_FAILURE,
  ASSET_LAST_UPLOAD_ACTIVEVIEW,
  ASSET_LAST_UPLOAD_EDIT,
  ASSET_LAST_UPLOAD_EDIT_SUCCESS,
  ASSET_LAST_UPLOAD_EDIT_FAILURE,
  ASSET_LAST_UPLOAD_SET_SELECT,
  ASSET_LAST_UPLOAD_UNSET_SELECT,
  ASSET_LAST_UPLOAD_EDIT_SELECT,
  ASSET_LAST_UPLOAD_DELETE,
  ASSET_LAST_UPLOAD_DELETE_SUCCESS,
  ASSET_LAST_UPLOAD_DELETE_FAILURE,
  ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT,
  ASSET_LAST_UPLOAD_EXPAND_SELECT,
  ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT,
  ASSET_LAST_UPLOAD_SHARE_SELECT,
  ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT,
  ASSET_LAST_UPLOAD_MOVE,
  ASSET_LAST_UPLOAD_MOVE_SUCCESS,
  ASSET_LAST_UPLOAD_FAILURE,
  ASSET_LAST_UPLOAD_CHECK_SELECT,
  ASSET_LAST_UPLOAD_UNCHECK_SELECT,
  MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE,
  MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE,
  MULTIPLE_LAST_UPLOAD_OPTIONS_DONE,
  ASSETS_LAST_UPLOAD_MULTI_DELETE,
  ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS,
  ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE,
  ASSETS_LAST_UPLOAD_MULTI_MOVE,
  ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS,
  ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE,
} from '../constants/assets-lastupload-types'
import { sendNotification, permissionsDefault, validateImageSpecialExtensions } from '../utils';
import store from '../store'


export const getLastUploads = (workclient, folderselect, page = 1, isFetching = true, data = []) => {
  const user = store.getState().authUser.user
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_GET_DATA,
      payload: {
        isFetching,
        data,
      },
    })
    BunkeyAPI({
      url: `/clients/${workclient}/last-uploads?page=${page}`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: ASSET_LAST_UPLOAD_GET_DATA_SUCCESS,
        payload: {
          user,
          folderselect,
          page,
          data: resp.data
            .map(r => {
              return {
                _id: r._id,
                type: validateImageSpecialExtensions(r.originalURL) ? 'document' : r.type,
                name: r.name,
                lowQualityURL: r.lowQualityURL,
                mediaQualityURL: r.mediaQualityURL,
                originalURL: r.originalURL,
                metadata: r.metadata,
                rightsState: r.rightsState,
                dueDate: r.dueDate,
                isContent: r.isContent,
                parents: r.parents,
                isSelected: false,
                createdAt: r.createdAt,
                group: r.group,
                user: r.user && r.username ? { id: r.user, name: r.username } : { id: '', name: '' },
                objectGroups: r.objectGroup,
                tagProtocol: r.tagProtocol,
                fileSizeFormat: r.fileSizeFormat,
                matrix: permissionsDefault().map(def => {
                  const exists = r.group.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
                  return {
                    action: def.action,
                    enabled: exists ? true : false
                  }
                }),
                uuid: r.uuid,
                documentPages: r.documentPages
              }
            }),
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_LAST_UPLOAD_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}


export const setSelectLastUploadAsset = (item, indice, from, verticalCount, horizontalCount) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_SET_SELECT,
      payload: {
        data: item,
        indice,
        from,
        verticalCount,
        horizontalCount
      }
    })
  }
}

export const unsetSelectLastUploadAsset = () => {
  return dispatch => {
    dispatch({ type: ASSET_LAST_UPLOAD_UNSET_SELECT })
  }
}

export const setLastUploadActiveView = view => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    })
  }
}

export const setEditLastUploadAsset = (workclient, asset) => {
  return dispatch => {
    dispatch({ type: ASSET_LAST_UPLOAD_EDIT })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        _id: asset._id,
        name: asset.name,
        metadata: {
          descriptiveTags: asset.metadata.descriptiveTags,
          createdDate: asset.metadata.createDate ? asset.metadata.createDate : asset.metadata.createdDate ? asset.metadata.createdDate : undefined,
          dueDate: asset.metadata.dueDate
        }
      }
    }).then(resp => {
      dispatch({
        type: ASSET_LAST_UPLOAD_EDIT_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: ASSET_LAST_UPLOAD_EDIT_FAILURE,
        payload: err
      })
    })
  }
}

export const setExpandLastUploadAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_EDIT_SUCCESS,
      payload: {
        data: asset,
      }
    })
  }
}

export const deleteLastUploadAsset = (workclient, id, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_LAST_UPLOAD_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${id}`,
      method: 'DELETE',
    }).then(resp => {
      dispatch({
        type: ASSET_LAST_UPLOAD_DELETE_SUCCESS,
        payload: {
          workclient,
          id
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_deleted' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_LAST_UPLOAD_DELETE_FAILURE,
        payload: {
          workclient,
          id,
          error: err
        }
      })
      // if (multiple) {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_deleting_asset' }))
      // }
    })
  }
}

export const setSelectEditLastUploadAsset = (asset, editAssetTab) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_EDIT_SELECT,
      payload: {
        data: asset,
        editAssetTab
      }
    })
  }
}

export const unsetSelectEditLastUploadAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_EDIT_UNSET_SELECT
    })
  }
}

export const setSelectExpandLastUploadAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_EXPAND_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectExpandLastUploadAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_EXPAND_UNSET_SELECT
    })
  }
}

export const setSelectShareLastUploadAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_SHARE_SELECT,
      payload: {
        data: asset,
      }
    })
  }
}

export const unsetSelectShareLastUploadAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_SHARE_UNSET_SELECT
    })
  }
}

export const moveLastUploadAsset = (workclient, asset, folder, intl, multiple) => {
  return dispatch => {
    dispatch({ type: ASSET_LAST_UPLOAD_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/${asset._id}`,
      method: 'PUT',
      data: {
        action: 'move',
        folder: folder
      }
    }).then(resp => {
      dispatch({
        type: ASSET_LAST_UPLOAD_MOVE_SUCCESS,
        payload: {
          data: asset,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: "asset_has_been_moved" }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSET_LAST_UPLOAD_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: "the_asset" })} ${asset.name} ${intl.formatMessage({ id: "could_not_move" })}`)
    })
  }
}

export const setCheckLastUploadAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_CHECK_SELECT,
      payload: asset
    })
  }
}
export const unsetCheckLastUploadAsset = (asset) => {
  return dispatch => {
    dispatch({
      type: ASSET_LAST_UPLOAD_UNCHECK_SELECT,
      payload: asset
    })
  }
}

export const activateLastUploadsOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_LAST_UPLOAD_OPTIONS_ACTIVATE
    })
  }
}

export const deactivateLastUploadsOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_LAST_UPLOAD_OPTIONS_DEACTIVATE
    })
  }
}

export const isDoneMultipeLastUploadsOptions = () => {
  return dispatch => {
    dispatch({
      type: MULTIPLE_LAST_UPLOAD_OPTIONS_DONE
    })
  }
}
export const multiDeleteLastUploadAsset = (workclient, intl, items) => {
  return (dispatch) => {
    dispatch({ type: ASSETS_LAST_UPLOAD_MULTI_DELETE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-deletemany`,
      method: 'PUT',
      data: {
        data: items
      }
    })
      .then((resp) => {
        dispatch({
          type: ASSETS_LAST_UPLOAD_MULTI_DELETE_SUCCESS,
          payload: {
            workclient,
            ids: items,
          },
        })
        sendNotification(
          'success',
          intl,
          intl.formatMessage({ id: "assets_has_been_deleted" })
        )
      })
      .catch((err) => {
        dispatch({
          type: ASSETS_LAST_UPLOAD_MULTI_DELETE_FAILURE,
          payload: {
            workclient,
            ids: items,
            error: err,
          },
        })
        sendNotification(
          'error',
          intl,
          `${intl.formatMessage({ id: 'assets_has_not_been_deleted' })}`
        )
      })
  }
}
export const moveMultiselectLastUploadAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_LAST_UPLOAD_MULTI_MOVE })
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: 'PUT',
      data: {
        data: ids
      }
    }).then(resp => {
      dispatch({
        type: ASSETS_LAST_UPLOAD_MULTI_MOVE_SUCCESS,
        payload: {
          ids: ids,
          headers: resp.headers
        }
      })
      // if (multiple) {
      sendNotification('success', intl, intl.formatMessage({ id: 'assets_have_been_moved' }))
      // }
    }).catch(err => {
      dispatch({
        type: ASSETS_LAST_UPLOAD_MULTI_MOVE_FAILURE,
        payload: err
      })
      sendNotification('error', intl, `${intl.formatMessage({ id: 'assets_could_not_moved' })}`)
    })
  }
}
